import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  typography: {
    fontFamily: [
      'Poppins',
      'sans-serif'
    ].join(','),
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,

  },
  palette: {
    primary: {
      light: '#007C86',
      main: '#005F6A',
      dark: '#003B41',
      contrastText: '#fff',
    },
    secondary: {
      light: '#33BDA9',
      main: '#00A896',
      dark: '#007864',
      contrastText: '#fff',
    },
    info: {
      light: '#333333',
      main: '#333333',
      dark: '#111111',

      contrastText: '#fff',
    },
    background: {
      default: '#FFFFFF',
      paper: '#E6F4F5',
    },
    text: {
      primary: '#333333',
      secondary: '#005F6A',
    },
  },
});
